const majorCategory = {
    path: '/majorManage/category',
    component: resolve => require(['@/views/majorManage/category'], resolve),
    name: 'majorCategory',
    meta: { title: '类别定价' }
};

const majorCityLevel = {
    path: '/majorManage/cityLevel',
    component: resolve => require(['@/views/majorManage/cityLevel'], resolve),
    name: 'majorCityLevel',
    meta: { title: '城市等级' }
};

const majorOpenArea = {
    path: '/majorManage/openArea',
    component: resolve => require(['@/views/majorManage/openArea'], resolve),
    name: 'majorOpenArea',
    meta: { title: '开通城市' }
};

const majorCoupon = {
    path: '/majorManage/coupon',
    component: resolve => require(['@/views/majorManage/coupon'], resolve),
    name: 'majorCoupon',
    meta: { title: '优惠卷管理' }
};

const majorCouponDetails = {
    path: '/majorManage/couponDetails',
    component: resolve => require(['@/views/majorManage/couponDetails'], resolve),
    name: 'majorCouponDetails',
    meta: { title: '优惠卷管理详情' }
};

const majorUserCategory = {
    path: '/majorManage/userCategory',
    component: resolve => require(['@/views/majorManage/userCategory'], resolve),
    name: 'majorUserCategory',
    meta: { title: '会干的活' }
};
const majorUserCategoryDetail = {
    path: '/majorManage/userCategoryDetail',
    component: resolve => require(['@/views/majorManage/userCategoryDetail'], resolve),
    name: 'majorUserCategoryDetail',
    meta: { title: '会干的活明细' }
};

const majorOrderList = {
    path: '/majorManage/needList',
    component: resolve => require(['@/views/majorManage/needList'], resolve),
    name: 'majorUserCategory',
    meta: { title: '定价列表' }
};

const majorUserApply = {
    path: '/majorManage/userApply',
    component: resolve => require(['@/views/majorManage/userApply'], resolve),
    name: 'majorUserApply',
    meta: { title: '工友申请' }
};

const majorBusinessCashExamine = {
    path: '/majorManage/businessCashExamine',
    component: resolve => require(['@/views/majorManage/businessCashExamine'], resolve),
    name: 'businessCashExamine',
    meta: { title: '提现业务审核' }
};

const majorFinanceCashExamine = {
    path: '/majorManage/financeCashExamine',
    component: resolve => require(['@/views/majorManage/financeCashExamine'], resolve),
    name: 'financeCashExamine',
    meta: { title: '提现财务审核' }
};

const majorCashApply = {
    path: '/majorManage/cashApply',
    component: resolve => require(['@/views/majorManage/cashApply'], resolve),
    name: 'cashApply',
    meta: { title: '提现申请' }
};

const majorDiscount = {
    path: '/majorManage/discount',
    component: resolve => require(['@/views/majorManage/discount'], resolve),
    name: 'discount',
    meta: { title: '优惠管理' }
};


const majorAppeal = {
    path: '/majorManage/appeal',
    component: resolve => require(['@/views/majorManage/appeal'], resolve),
    name: 'appeal',
    meta: { title: '申诉管理' }
};

const majorRefund = {
    path: '/majorManage/refund',
    component: resolve => require(['@/views/majorManage/refund'], resolve),
    name: 'refund',
    meta: { title: '退款管理' }
};

const supervisor = {
    path: '/majorManage/supervisor',
    component: resolve => require(['@/views/majorManage/supervisor'], resolve),
    name: 'supervisor',
    meta: {
        title: '监理管理',
    }
};

const customMade = {
    path: '/majorManage/customMade',
    component: resolve => require(['@/views/majorManage/customMade'], resolve),
    name: 'customMade',
    meta: {
        title: '定制服务',
    }
};

const majorIndex = {
    path: '/majorManage/index',
    component: resolve => require(['@/views/majorManage/index'], resolve),
    name: 'majorIndex',
    meta: { title: '测试' }
};

export default [
    majorCategory,
    majorCityLevel,
    majorOpenArea,
    majorUserCategory,
    majorUserCategoryDetail,
    majorOrderList,
    majorUserApply,
    majorIndex,
    majorBusinessCashExamine,
    majorFinanceCashExamine,
    majorCashApply,
    majorDiscount,
    majorAppeal,
    majorRefund,
    majorCoupon,
    majorCouponDetails,
    supervisor,
    customMade
]



// WEBPACK FOOTER //
// ./src/router/modules/major.js